<template>
  <div class="auth">
    <!-- <header>
      <img class="logo" src="@/assets/imgs/logo3.jpeg" alt />
    </header> -->
    <div class="language-counter">
      <span
        class="language"
        :class="{ active: language == 'CN' }"
        @click="handleChangeLanguage('CN')"
        >中文</span
      >
      <span style="color: #0b92fb">|</span>
      <span
        class="language"
        :class="{ active: language == 'EN' }"
        @click="handleChangeLanguage('EN')"
        >EN</span
      >
    </div>
    <div class="logo-image">
      <img src="@/assets/imgs/product_logo.png" alt="" />
    </div>
    <div class="shop-login-title">{{ $t("scanLoginTitle") }}</div>
    <div class="form-box">
      <div>
        <div class="form-item">
          <van-cell-group>
            <van-field
              v-model="phone"
              :placeholder="$t('loginPhonePlaceholder')"
            />
          </van-cell-group>
        </div>
        <div class="form-item">
          <van-cell-group>
            <van-field
              v-model="verificationCode"
              :placeholder="$t('loginVerificationCodePlaceholder')"
            >
              <template #button>
                <van-button
                  style="margin: 0"
                  size="small"
                  type="primary"
                  @click="handleGetVerificationCode"
                  >{{ countFlag ? $t("getVCode") : countdown }}</van-button
                >
              </template></van-field
            >
          </van-cell-group>
        </div>
        <div class="form-item">
          <van-cell-group>
            <van-field
              v-model="password"
              type="password"
              :placeholder="$t('loginPasswordPlaceholder')"
            />
          </van-cell-group>
        </div>
      </div>
      <div class="form-item">
        <button :disabled="isDis" @click="handleSubmit">
          {{ loginStatus ? $t("loginBtnIng") : $t("loginBtn") }}
        </button>
      </div>
      <div class="form-item info">
        <!-- <router-link to="/register" class="link" replace>去注册</router-link> -->
      </div>
    </div>
    <!-- </main> -->
  </div>
</template>

<script>
import { resetScroll } from "@/common/dom";
import { toGateway } from "../gateway";
import { consume, cuCodeRex } from "./location";
const SM4 = require("gm-crypt").sm4;

let sm4Config = {
  // encrypt/decypt main key; cannot be omitted
  key: "yunpengai.306-01",

  // optional; can be 'cbc' or 'ecb'
  mode: "cbc", // default

  // optional; when use cbc mode, it's �necessary
  iv: "abcdef9876543210", // default is null

  // optional: this is the cipher data's type; Can be 'base64' or 'text'
  cipherType: "base64", // default is base64
};

const sm4 = new SM4(sm4Config);

export default {
  data() {
    return {
      loginStatus: 0,
      rselectAdio: "2",
      ruleChecked: false,
      userPhone: "",
      userCode: "",
      username: localStorage.getItem("userName") || "",
      phone: localStorage.getItem("phone") || "",
      password: "",
      countFlag: true,
      countdown: 59,
      activeIcon: require("../../assets/image/activeIcon.png"),
      inactiveIcon: require("../../assets/image/inactiveIcon.png"),
      hidePatientLogin: false,
      language: localStorage.getItem("language") || "CN",
      verificationCode: "",
      memberNo: "",
    };
  },
  computed: {
    isDis() {
      return !this.password || !this.phone || !this.verificationCode;
    },
    isCode() {
      return !this.userPhone || !this.userCode;
    },
  },
  created() {},
  mounted() {
    if (localStorage.getItem("ruleChecked")) {
      this.ruleChecked = localStorage.getItem("ruleChecked");
    }
  },
  methods: {
    handleChangeLanguage(type) {
      this.language = type;
      localStorage.setItem("language", this.language);
      window.location.reload();
    },
    onBlur() {
      resetScroll();
    },
    async handleSubmit() {
      // if (!this.ruleChecked) {
      //   return this.$toast("请阅读并同意《用户协议及隐私政策》");
      // }
      localStorage.setItem("ruleChecked", this.ruleChecked);
      if (this.loginStatus) {
        return;
      }
      if (this.isDis) {
        this.$toast("请输入账号和密码");
        return;
      }
      this.loginStatus = 1;
      const { phone, password, verificationCode } = this;
      try {
        const { data: resData } = await this.$logina.post(
          "/api/wxapp/loginWithPhoneAndPasswordSms",
          {
            password,
            phone,
            verificationCode
          }
        );
        if (resData.code == 200) {
          // - phone

          localStorage.setItem("showQuit", "1");
          localStorage.setItem("loginType", "user");
          localStorage.setItem("userName", this.username);
          //
          localStorage.setItem("phone", this.phone);
          localStorage.setItem("password", this.password);
          localStorage.setItem(
            "customerInfoList",
            JSON.stringify(resData.data.customerList)
          );
          if (resData.data.token) {
            sessionStorage.setItem("token", resData.data.token);
          }

          // 判断是否需要修改手机号
          const customerList = JSON.parse(
            localStorage.getItem("customerInfoList")
          );
          if (customerList && customerList.length > 0) {
            const resetPassword = customerList[0].resetPassword;
            if (resetPassword == 1) {
              return this.$router.replace("/repass?repass=1");
            }
          }
          this.$toast(this.$t("loginSuccess"));
          // 跳转到设置的首页
          // 做 locationId 判定
          const locationId = localStorage.getItem("locationId");
          if (!consume(locationId)) {
            const isTo = toGateway();
            if (!isTo) {
              this.$router.replace("/page");
            }
          }
        } else {
          this.$toast(resData.message);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      this.loginStatus = 0;
    },
    handleProtocol() {
      this.$router.push("/auth/protocol");
    },
    // 获取验证码
    async handleGetVerificationCode() {
      if (!this.phone) return this.$toast($t("loginPhonePlaceholder"));
      this.countFlag = false;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown == 0) {
          clearInterval(timer);
          this.countFlag = true;
          this.countdown = 59;
        }
      }, 1000);
      try {
        let data = {
          customerPhone: this.phone,
        };
        const { data: resData } = await this.$logina.post(
          "/api/wxapp/sendVerificationCode",
          data
        );
        if (resData.code == 200) {
          this.$toast.success(this.$t("loginToastSendSuccess"));
        }
      } catch (err) {
        clearInterval(timer);
        this.countFlag = true;
        this.countdown = 59;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .van-radio__label {
  font-size: 12px;
  color: #666;
}
</style>
<style lang="scss" scoped>
@import "./auth.scss";

.link {
  padding: 10px;
  color: #2aafe7;
  font-size: 16px;
}

.default {
  font-size: 12px;
  color: #ccc;
  margin-left: 10px;
  margin-top: -5px;
}

.df {
  display: flex;
  align-items: center;

  .select {
    color: #666;
    font-size: 14px;
  }
}

.checkbox {
  // display: flex;
  // align-items: center;
  margin-top: 20px;
  margin-left: 60px;

  .agreen {
    font-size: 13px;
  }

  .protocol {
    font-size: 13px;
    color: #0a81ad;
  }
}

.df {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e1e1e1;
  .code-btn {
    font-size: 13px;
    width: 78px;
    height: 30px;
    background: #1479ff;
    margin-left: 3px;
    border-radius: 5px;
    color: #ffffff;
    text-align: center;
    line-height: 30px;
  }
}
</style>
